import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { SnackbarProvider } from "notistack";
import Layout from "./components/Layout";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const ToolExplorer = lazy(() => import("./pages/ToolExplorer"));
const ToolDetail = lazy(() => import("./pages/ToolDetail"));
const Settings = lazy(() => import("./pages/Settings"));

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#6c5ce7" },
    secondary: { main: "#a29bfe" },
    background: {
      default: "#0f1117",
      paper: "#1a1d27",
    },
    success: { main: "#00b894" },
    error: { main: "#e17055" },
    warning: { main: "#fdcb6e" },
    info: { main: "#74b9ff" },
  },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
  },
});

const Loading = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh", color: "#8b90a0" }}>
    Loading...
  </div>
);

export default function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <BrowserRouter>
          <Layout>
            <Suspense fallback={<Loading />}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/tools" element={<ToolExplorer />} />
                <Route path="/tools/:toolName" element={<ToolDetail />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </Suspense>
          </Layout>
        </BrowserRouter>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
